export enum CarSource {
  GOGOOUT = 'gogoout',
  HERTZ = 'hertz',
}

export default CarSource
